<script setup lang="ts">
import { watch } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { loadPylonWidget } from '@/utils/chat-utils'
import { togglePylonBubble } from '@/utils/toggle-pylon'

const auth = useAuthStore()
const appId = document.querySelector<HTMLMetaElement>('meta[name="pylon-app-id"]')?.content

watch(
  () => [auth.isAuthenticated, auth.user] as const,
  async ([authenticated, user]) => {
    if (!appId) return

    if (authenticated && user) {
      const orgName = auth.organizationName ?? ''
      const displayName = orgName ? `${user.name} - ${orgName}` : user.name

      window.pylon = {
        chat_settings: {
          app_id: appId,
          name: displayName,
          email: user.email,
          email_hash: auth.pylonHmac ?? undefined,
        },
      }

      try {
        await loadPylonWidget(appId)
        togglePylonBubble(true)
      } catch {
        // Widget failed to load - silently degrade
      }
    } else {
      togglePylonBubble(false)
    }
  },
  { immediate: true },
)
</script>

<template>
  <div />
</template>
